import { Component } from '@badideagames/engine';

export class Gravity extends Component {
  force: number = 800;
}
